// @flow

import * as React from 'react';
import Promise from 'bluebird';

const evtNames = [
  'click',
  'dblclick',
  'dragend',
  'mousedown',
  'mouseout',
  'mouseover',
  'mouseup',
  'recenter',
];

const wrappedPromise = () => {
  const wrappedPromiseRes = {};
  const promise = new Promise((resolve, reject) => {
    wrappedPromiseRes.resolve = resolve;
    wrappedPromiseRes.reject = reject;
  });
  wrappedPromiseRes.then = promise.then.bind(promise);
  wrappedPromiseRes.catch = promise.catch.bind(promise);
  wrappedPromiseRes.promise = promise;

  return wrappedPromiseRes;
};

type Props = {
  position: Object,
  map: Object,
  mapCenter: Object,
  icon: Object,
  label: string,
  draggable: boolean,
  title: string,
  google: Object,
  children?: React.Node,
  name: string,
}

type State = {}

class GMMarker extends React.Component<Props, State> {
  static defaultProps: {
    name: 'Marker',
    children: null,
  };

  markerPromise: Object;
  marker: Object;

  componentDidMount() {
    this.markerPromise = wrappedPromise();
    this.renderMarker();
  }

  camelize = (str: string) =>
    str.split(' ').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1))
      .join('');

  componentDidUpdate(prevProps: Props) {
    if (prevProps.map !== this.props.map ||
      (JSON.stringify(this.props.position) !== JSON.stringify(prevProps.position)) ||
      (JSON.stringify(this.props.icon) !== JSON.stringify(prevProps.icon))) {
      if (this.marker) {
        this.marker.setMap(null);
      }
      this.renderMarker();
    }
  }

  componentWillUnmount() {
    if (this.marker) {
      this.marker.setMap(null);
    }
  }

  renderMarker = () => {
    const {
      map,
      google,
      position,
      mapCenter,
      icon,
      label,
      draggable,
      title,
      ...props
    } = this.props;
    if (!google) {
      return;
    }

    let pos = position || mapCenter;
    if (!(pos instanceof google.maps.LatLng)) {
      pos = new google.maps.LatLng(pos.lat, pos.lng);
    }

    const pref = {
      map,
      position: pos,
      icon,
      label,
      title,
      draggable,
      ...props,
    };
    this.marker = new google.maps.Marker(pref);

    evtNames.forEach((e) => {
      this.marker.addListener(e, this.handleEvent(e));
    });

    this.markerPromise.resolve(this.marker);
  };

  getMarker = () => this.markerPromise;

  handleEvent = (evt: string) =>
    (e: EventHandler) => {
      const evtName = `on${this.camelize(evt)}`;
      if (this.props[evtName]) {
        this.props[evtName](this.props, this.marker, e);
      }
    };

  render() {
    return (
      <React.Fragment>
        {this.props.children && this.marker ?
          React.Children.only(React.cloneElement(
            this.props.children,
            {
              marker: this.marker,
              google: this.props.google,
              map: this.props.map,
            },
          )) : null
        }
      </React.Fragment>
    );
  }
}

// evtNames.forEach(e => GMMarker.propTypes[e] = PropTypes.func)

export default GMMarker;

